import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedSection.css';

export interface Props {
  title: string
  subtitle: string
  button: string
  img: string
}

function FeaturedSection(props : Props) {
  return (
    <div className="FeaturedSection"
    style={{
      // backgroundImage: `url(${props.img})`
      backgroundImage: `url(${props.img})`
    }}>
      <div>
        <h2>{props.title}</h2>
        <p>{props.subtitle}</p>
      </div>
        <Link to="/contacts" className='primary white'>{props.button}</Link>
    </div>
  );
}

export default FeaturedSection;
